import { withCurrencyLogo } from '@pancakeswap/uikit'
import { Currency } from '@pancakeswap/sdk'
import { CurrencyLogo } from '../Logo'

export default withCurrencyLogo<Currency>(CurrencyLogo)
